<style scoped></style>
<template>
  <router-link :to="'/map/?m=' + map.map_id">
    <v-card style="overflow: hidden;">
      <div style="position: relative;">
        <picture v-if="map.image">
          <source type="image/webp" :srcset="imageRoot + map.image + '_200x200.webp'"/>
          <img style="object-fit: cover; height: 100px; width: 100%;" :src="imageRoot + map.image + '_200x200.png'">
        </picture>
        <div v-else style="background: grey; height: 100px; width: 100%; text-align: center; line-height: 100px;">
          <span style="color: dimgrey; text-align: center" class="text-h5 font-weight-bold">No Image</span>
        </div>
        <v-card-title style="position: absolute; bottom: 0; text-shadow: 0 0 4px #666;"
                      class="white--text font-weight-bold pb-1 pl-2">{{ map.title }}</v-card-title>
      </div>
      <v-card-actions class="pb-0">
        <img v-if="map.userImage" style="height: 40px; width: 40px; object-fit: cover; border-radius: 50%;" :src="imageRoot + map.userImage + '_100x100.png'"/>
        <v-icon v-else color="grey" x-large>mdi-account-circle</v-icon>
        <v-card-text class="pa-2 text-subtitle-1">{{ map.userName }}</v-card-text>
      </v-card-actions>
      <v-card-text class="py-0">
        <small>{{ map.made }}</small>
      </v-card-text>
      <v-card-text class="py-2" style="text-overflow:ellipsis; overflow: hidden; white-space: nowrap;">
        {{ map.description }}
      </v-card-text>
    </v-card>
  </router-link>
</template>
<script>
export default {
  name: "MapCard",
  props: {
    map: {
      type: Object
    }
  },
  mounted() {},
  data: () => ({}),
  methods: {},
  computed: {
    imageRoot: function () {
      return this.$store.getters.get.imageRoot;
    },
  },
};
</script>
